module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/anastasi17-bkg-5212aedd33d57e4df0ed955c0a9fc510.jpg";